<template lang="pug">
.cp-content-list1
  .item(v-for="v in list")
    .wrap.w.fix
      .text-wrap.fl
        p {{ v.title }}
        p {{ v.content }}
        .labels-wrap(v-for="v1 in v.labels")
          icon.icon(iconClass="icongou")
          span {{ v1 }}
      img(:src="v.imgSrc", :style="v.imgStyle")
</template>
<script>
export default {
  components: {},
  props: {
    list: {
      type: Array,
    }
  },
  data () {
    return {

    }
  },
  computed: {},
  methods: {}
}
</script>
<style lang="stylus">
.cp-content-list1
  .item
    height 500px
    .wrap
      padding-top 60px
      .text-wrap
        width 300px
        padding-top 40px
        p
          &:first-child
            font-size 24px
            font-weight 600
          &:nth-child(2)
            font-size 16px
            margin-top 20px
            margin-bottom 10px
            color rgba(244,245,247,1)
        .labels-wrap
          margin-bottom 10px
          color rgba(244,245,247,1)
          span
            font-size 16px
          .icon
            margin-right 6px
      img
        width 639px
    &:nth-child(2n+1)
      background #0D1E47
      .text-wrap
        margin-left 60px
      img
        float right
        margin-right 80px
    &:nth-child(2n+2)
      background #0D1634
      .text-wrap
        float right
      img
        margin-left 80px
    &:nth-child(2)
      .wrap
        padding-top 50px

</style>
